import { createAsyncThunk } from "@reduxjs/toolkit";
import { getIndireactIncomeBalanceApi } from "../../../apiservice/dashboard";
import { getAccountBySeachApi } from "../../../apiservice/setting";

export const fetchIndirectIncomeBalance = createAsyncThunk(
  "indirectIncomeBalance/fetch",
  async ({ filters }, { rejectWithValue }) => {
    try {
      const payload = {
        accId:
          filters.filterType === "Account Wise" ? filters?.accId || null : null,
        fromDate:
          filters.filterType === "Date Wise" ? filters?.fromDate || null : null,
        toDate:
          filters.filterType === "Date Wise" ? filters?.toDate || null : null,
      };
      const res = await getIndireactIncomeBalanceApi(payload);

      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

export const fetchIndirectIncomeAccountsBySearch = createAsyncThunk(
  "indirectIncomeBalance/fetchAccountsBySearch",
  async (search, { rejectWithValue }) => {
    try {
      const res = await getAccountBySeachApi({
        query: search.trim(),
        multiType: ["indirect_income"],
      });
      return (res.data || []).map((c) => ({
        sale_id: c.acc_id,
        display_text: c.acc_name,
      }));
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);
